module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/billing/workslip-statement/workslip-statement.component.css
// module id = ./src/app/technical/billing/workslip-statement/workslip-statement.component.css
// module chunks = main